import React from "react";
import CmsShimmer from "./CmsShimmer";

export function SkeletonSectionCard({ children, id }) {
  return (
    <section className="cms-section-card cms-section-card--skeleton" id={id}>
      <div className="cms-section-card__header cms-section-card__header--static">
        <div className="cms-skeleton__section-head">
          <CmsShimmer className="cms-skeleton__title" />
          <CmsShimmer className="cms-skeleton__desc" />
        </div>
      </div>
      <div className="cms-section-card__body">{children}</div>
    </section>
  );
}

export function SkeletonStickyNav({ count = 5 }) {
  return (
    <nav className="cms-sticky-nav cms-sticky-nav--skeleton" aria-hidden="true">
      {Array.from({ length: count }, (_, i) => (
        <CmsShimmer key={i} className="cms-skeleton__nav-pill" />
      ))}
    </nav>
  );
}

export function SkeletonBilingualTableHeader() {
  return (
    <div className="cms-bilingual-head cms-skeleton__bilingual-head" aria-hidden="true">
      <CmsShimmer className="cms-skeleton__head-label" />
      <CmsShimmer className="cms-skeleton__head-col cms-skeleton__head-col--en" />
      <CmsShimmer className="cms-skeleton__head-col cms-skeleton__head-col--es" />
    </div>
  );
}

export function SkeletonBilingualRow({ tall = false }) {
  return (
    <div className="cms-bilingual-row cms-skeleton__bilingual-row" aria-hidden="true">
      <div className="cms-bilingual-row__label">
        <CmsShimmer className="cms-skeleton__field-label" />
        <CmsShimmer className="cms-skeleton__field-key" />
      </div>
      <CmsShimmer className={`cms-skeleton__input${tall ? " cms-skeleton__input--tall" : ""}`} />
      <CmsShimmer className={`cms-skeleton__input${tall ? " cms-skeleton__input--tall" : ""}`} />
    </div>
  );
}

export function SkeletonBilingualImageRow() {
  return (
    <div className="cms-bilingual-image-block cms-skeleton__image-block" aria-hidden="true">
      <CmsShimmer className="cms-skeleton__field-label cms-skeleton__field-label--block" />
      <div className="cms-bilingual-image-block__cols">
        <SkeletonImageCell />
        <SkeletonImageCell />
      </div>
    </div>
  );
}

function SkeletonImageCell() {
  return (
    <div className="cms-bilingual-image-cell">
      <CmsShimmer className="cms-skeleton__lang-chip" />
      <CmsShimmer className="cms-skeleton__thumb" />
      <CmsShimmer className="cms-skeleton__upload-btn" />
    </div>
  );
}

export function SkeletonRepeaterBlocks({ count = 3, columns = 1 }) {
  const gridClass =
    columns === 3
      ? "cms-feature-grid"
      : columns === 2
        ? "cms-trust-grid"
        : "cms-skeleton__repeater-stack";

  return (
    <div className={gridClass} aria-hidden="true">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="cms-bilingual-block cms-skeleton__repeater-block">
          <CmsShimmer className="cms-skeleton__chip" />
          <SkeletonBilingualRow />
          <SkeletonBilingualRow tall />
          <SkeletonBilingualImageRow />
        </div>
      ))}
    </div>
  );
}

export function SkeletonHeroBlock() {
  return (
    <>
      {Array.from({ length: 5 }, (_, i) => (
        <SkeletonBilingualRow key={`t-${i}`} tall={i === 4} />
      ))}
      <SkeletonBilingualImageRow />
      <SkeletonBilingualImageRow />
    </>
  );
}

export function SkeletonLangStatusCards() {
  return (
    <>
      <div className="cms-lang-status-card cms-lang-status-card--skeleton" aria-hidden="true">
        <CmsShimmer className="cms-skeleton__status-chip" />
        <CmsShimmer className="cms-skeleton__status-time" />
      </div>
      <div className="cms-lang-status-card cms-lang-status-card--skeleton" aria-hidden="true">
        <CmsShimmer className="cms-skeleton__status-chip" />
        <CmsShimmer className="cms-skeleton__status-time" />
      </div>
    </>
  );
}
